
<div class="modal-dialog" style="max-width: 600px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4>Select Printer</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row justify-content-center">
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th>SKU</th>
              <th>Description</th>
              <th>Device Key</th>
              <th>Bundle Number</th>
              <th>Serial Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-asset [ngForOf]="availableAssets">
              <tr>
                <td>{{ asset.productNumber }}</td>
                <td>{{ asset.friendlyName || asset.description }}</td>
                <td>{{ asset.deviceKey }}</td>
                <td>{{ asset.bundleNumber }}</td>
                <td>{{ asset.serialNumber }}</td>
                <td>
                  <div class="btn-group">
                    <button class="btn btn-outline-primary btn-sm" (click)="associate(asset)" [disabled]="asset.installed || asset.ordered">Associate</button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <tr *ngIf="availableAssets.length === 0">
              <td colspan="8">
                <p class="text-center empty-table-message">There are no assets to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <div class="float-right">
        <div class="btn-group">
          <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>